var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamily(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 5.6C2.46188 5.6 3 5.06187 3 4.4C3 3.73812 2.46188 3.2 1.8 3.2C1.13813 3.2 0.6 3.73812 0.6 4.4C0.6 5.06187 1.13813 5.6 1.8 5.6ZM10.2 5.6C10.8619 5.6 11.4 5.06187 11.4 4.4C11.4 3.73812 10.8619 3.2 10.2 3.2C9.53813 3.2 9 3.73812 9 4.4C9 5.06187 9.53813 5.6 10.2 5.6ZM10.8 6.2H9.6C9.27 6.2 8.97188 6.33312 8.75438 6.54875C9.51 6.96312 10.0463 7.71125 10.1625 8.6H11.4C11.7319 8.6 12 8.33187 12 8V7.4C12 6.73812 11.4619 6.2 10.8 6.2ZM6 6.2C7.16063 6.2 8.1 5.26062 8.1 4.1C8.1 2.93937 7.16063 2 6 2C4.83938 2 3.9 2.93937 3.9 4.1C3.9 5.26062 4.83938 6.2 6 6.2ZM7.44 6.8H7.28438C6.89438 6.9875 6.46125 7.1 6 7.1C5.53875 7.1 5.1075 6.9875 4.71563 6.8H4.56C3.3675 6.8 2.4 7.7675 2.4 8.96V9.5C2.4 9.99687 2.80313 10.4 3.3 10.4H8.7C9.19688 10.4 9.6 9.99687 9.6 9.5V8.96C9.6 7.7675 8.6325 6.8 7.44 6.8ZM3.24563 6.54875C3.02813 6.33312 2.73 6.2 2.4 6.2H1.2C0.538125 6.2 0 6.73812 0 7.4V8C0 8.33187 0.268125 8.6 0.6 8.6H1.83563C1.95375 7.71125 2.49 6.96312 3.24563 6.54875Z",
    fill: "#4A3F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.5bd7c0e2e351abcf76b0bd995056f8b8.svg";
export { ForwardRef as ReactComponent };